import React from 'react';
import { CommonFilterFields } from 'constants/filters/commonFilterFields';
import { FilterInputsForm } from './FilterInputsForm/FilterInputsForm';
import { DateRangeFilter } from './DateRangeFilter/DateRangeFilter';

export function DateRangeForm() {
  return (
    <FilterInputsForm fields={CommonFilterFields}>
      <DateRangeFilter />
    </FilterInputsForm>
  );
}
